/**
 * Apple Sign In JS API
 * 与 Google 登录并列，流程一致：前端拿 id_token → 调后端 /authorize/apple/token → 根据返回走 bind-third / set-password / 登录成功
 * 参考：https://developer.apple.com/documentation/sign_in_with_apple/sign_in_with_apple_js
 *
 * 若出现 "Invalid web redirect url"：redirect_uri 必须与 Apple 开发者后台
 * (Identifiers → 你的 App ID → Sign in with Apple → Configure → Return URLs) 里配置的 URL 完全一致。
 */
export const APPLE_CLIENT_ID = "com.spikex.Login";

export const APPLE_SCRIPT_SRC = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";

/**
 * 若设置则优先使用（用于 ngrok/测试等），否则用当前页 origin + /auth/apple/callback
 * 需与 Apple 开发者后台 Return URLs 完全一致
 */
const APPLE_REDIRECT_URI_OVERRIDE =
  typeof process !== "undefined" && process.env?.NEXT_PUBLIC_APPLE_REDIRECT_URI
    ? process.env.NEXT_PUBLIC_APPLE_REDIRECT_URI.trim()
    : "";

/** 当前页面的 Apple 回调地址，需与 Apple 开发者后台配置的 Return URLs 完全一致（否则会报 Invalid web redirect url） */
export function getAppleRedirectUri() {
  if (APPLE_REDIRECT_URI_OVERRIDE) return APPLE_REDIRECT_URI_OVERRIDE;
  if (typeof window === "undefined") return "";
  const origin = window.location?.origin ?? "";
  if (!origin) return "";
  return `${origin}/auth/apple/callback`;
}

/** 获取 Apple Sign In init 传参，便于调试打印；redirectURI 为空时不要调用 init */
export function getAppleInitConfig() {
  const redirectURI = typeof window !== "undefined" ? getAppleRedirectUri() : "";
  return { clientId: APPLE_CLIENT_ID, scope: "email", redirectURI, usePopup: true };
}
